const router = [
  {
    path: '/contract/sign/:contractNo/:tenantId',
    name: 'ContractSign',
    component: () => import('@/views/contract/ContractSign.vue'),
    meta: {
      title: '合同签署',
      checkToken: false
    }
  },
  {
    path: '/contract/transfer',
    name: 'ContractTransfer',
    component: () => import('@/views/contract/ContractTransfer.vue'),
    meta: {
      title: '打开App',
      checkToken: false
    }
  }
];
export default router;
